import getLastModuleKey from "~/pwa/getLastModuleKey";
import { findAppByKey, type InstallableApp } from "~/pwa/installableApps";
import lastModuleStorageKey from "~/pwa/lastModuleStorageKey";

export const recordLastModuleApp = (app: InstallableApp | null): void => {
	if (typeof localStorage === "undefined" || !app) return;
	try {
		localStorage.setItem(lastModuleStorageKey, app.key);
	} catch {
		return;
	}
};

export const getLastModuleApp = (): InstallableApp | null => findAppByKey(getLastModuleKey());

export default getLastModuleApp;
